import fetchIntercept from "fetch-intercept";
import { ACCESS_TOKEN_KEY } from "./main/utilities/Constants";
 
const registerInterceptors = () => {
  const unregister = fetchIntercept.register({
    request: function (url, config) {
      console.log("URL intercepted:" + url);
      const accessToken = JSON.parse(
        sessionStorage.getItem(ACCESS_TOKEN_KEY) || "{}"
      );
      const currentTime = Math.round(new Date().getTime() / 1000);
      const expiredTokenTime = accessToken?.issuedAt + accessToken?.expiresIn;
      if (accessToken?.accessToken && currentTime >= expiredTokenTime) {
        try {
          window.location.href = process.env.REACT_APP_LOGOUT_URI;
          console.log("Token expired");
          return new Promise(() => {});
        } catch (error) {
          console.log("Error parsing token after logout.");
        }
      }
      return [url, config];
    },
  });
 
  return unregister; // Return the unregister function for cleanup if needed
};
 
export default registerInterceptors;